import { useContext } from 'react';

import { SideNavContext } from './SideNavContext';
import type { SideNavState } from './SideNavState';

export const useSideNav = (): SideNavState => {
	const context = useContext(SideNavContext);
	if (context === undefined) {
		throw new Error('useSideNav must be used within a SideNavProvider');
	}
	return context;
};
